import Styled from 'styled-components';

import { StatusModalContainerStyle } from './StatusModalContainerStyle';

export const StatusModalContainer = Styled.div`
  ${StatusModalContainerStyle}

  text-align: center;

  & * {
    text-align: center;
  }
`;
